import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../Services/HomeService";
import HttpClientXml from "../utils/HttpClientXml";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const AddAdvertisementNew = () => {
  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [cities, setCities] = useState([]);

  const initialFormData = {
    city: "",
    media: "",
    description: "", // Added description field
  };

  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [mediaType, setMediaType] = useState(""); // "image" or "video"
  const navigate = useNavigate();

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setFormData({ ...formData, [name]: value });
  };

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        setCities(res.data);
        if (userCity) {
          setCities([res.data.find((item) => item._id === userCity)]);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      toast.error("Failed to fetch cities");
    }
  };

  const handleMediaUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Determine media type
    let type = "";
    if (file.type.startsWith("image/")) {
      type = "image";
    } else if (file.type.startsWith("video/")) {
      type = "video";
    } else {
      toast.error("Please select a valid image or video file");
      return;
    }

    // // Validate file size based on type
    // const maxSize = type === "image" ? 10 * 1024 * 1024 : 50 * 1024 * 1024; // 10MB for images, 50MB for videos
    // if (file.size > maxSize) {
    //   toast.error(
    //     `${type === "image" ? "Image" : "Video"} size should be less than ${
    //       maxSize / (1024 * 1024)
    //     }MB`
    //   );
    //   return;
    // }

    setMediaLoading(true);
    setMediaType(type);

    const data = new FormData();
    data.append("image", file);

    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setFormData((prev) => ({ ...prev, media: res.image }));
        toast.success(
          `${type === "image" ? "Image" : "Video"} uploaded successfully!`
        );
      } else {
        toast.error(res?.message || `Failed to upload ${type}`);
      }
    } catch (error) {
      toast.error(`Failed to upload ${type}.`);
      console.error(`Error uploading ${type}:`, error);
    } finally {
      setMediaLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.city) {
      return toast.error("Please select a city");
    }
    if (!formData.media) {
      return toast.error("Please upload a media file (image or video)");
    }
    if (!formData.description.trim()) {
      // Added validation for description
      return toast.error("Please enter a description");
    }

    console.log("Advertisement Data:", formData);

    setLoading(true);
    try {
      const res = await HomeService.addAdvertisementNew(formData);
      if (res?.status) {
        toast.success("Advertisement added successfully!");
        setFormData(initialFormData);
        setMediaType("");
        navigate("/manage-advertisement-for-city");
      } else {
        toast.error(res?.message || "Failed to add advertisement");
      }
    } catch (error) {
      toast.error("Failed to add advertisement.");
      console.error("Error adding advertisement:", error);
    } finally {
      setLoading(false);
    }
  };

  const removeMedia = () => {
    setFormData((prev) => ({ ...prev, media: "" }));
    setMediaType("");
    toast.success("Media removed");
  };

  useEffect(() => {
    fetchCities();
  }, []);

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Add New Advertisement
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* City Selection */}
                <div className="col-md-6 mt-3">
                  <label>
                    City<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="city"
                    value={formData?.city || ""}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>
                      ---Select City---
                    </option>
                    {cities.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Media Upload */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="media">
                    Advertisement Media (Image or Video)
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="file"
                    id="media"
                    className="form-control"
                    onChange={handleMediaUpload}
                    accept="image/*,video/*"
                    disabled={mediaLoading}
                    required
                  />
                  <div className="form-text">
                    {mediaLoading ? (
                      <span className="text-primary">
                        <i className="fa-solid fa-spinner fa-spin me-1"></i>
                        Uploading {mediaType}...
                      </span>
                    ) : (
                      ""
                    )}
                  </div>

                  {formData.media && (
                    <div className="mt-3 position-relative">
                      <div className="alert alert-success p-2">
                        <strong>
                          {mediaType === "image"
                            ? "Image Preview:"
                            : "Video Preview:"}
                        </strong>
                      </div>

                      {mediaType === "image" ? (
                        <img
                          src={formData.media}
                          alt="Advertisement"
                          style={{
                            maxHeight: "200px",
                            maxWidth: "100%",
                            borderRadius: "8px",
                            border: "2px solid #dee2e6",
                          }}
                        />
                      ) : (
                        <video
                          controls
                          style={{
                            maxHeight: "200px",
                            maxWidth: "100%",
                            borderRadius: "8px",
                            border: "2px solid #dee2e6",
                          }}
                        >
                          <source src={formData.media} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      )}

                      <button
                        type="button"
                        onClick={removeMedia}
                        className="btn btn-danger btn-sm position-absolute"
                        style={{ top: "35px", right: "10px" }}
                      >
                        <i className="fa-solid fa-times"></i>
                      </button>
                    </div>
                  )}
                </div>

                {/* Description Textarea - Added new field */}
                <div className="col-12 mt-3">
                  <label htmlFor="description">
                    Description<span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="description"
                    className="form-control"
                    name="description"
                    value={formData?.description || ""}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Enter advertisement description..."
                    required
                  ></textarea>
                  <div className="form-text">
                    Enter a detailed description for this advertisement
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="row mt-4">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      padding: "10px 30px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    disabled={loading || mediaLoading}
                  >
                    {loading ? (
                      <>
                        <i className="fa-solid fa-spinner fa-spin me-2"></i>
                        Adding...
                      </>
                    ) : (
                      "Add Advertisement"
                    )}
                  </button>
                </div>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AddAdvertisementNew;
